const Config={}

export default Config